import styled from 'styled-components';

export const PublicModuleStyle = {
  Container: styled.div``,
};
